export { default as StrategyCenterMarker } from './StrategyCenterMarker';
